<div class="lessons-list">
  <!-- Lessons Header -->
  <div class="lessons-list__header">
    <div class="lessons-list__header-container">
      <div class="lessons-list__header-title">
        <div class="lessons-list__header-title-text">
          {{ 'app.components.courseCreator.publish.lessonsInformation.title' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Lessons Card -->
  <div class="lessons-list__card">
    @for (task of tasks(); track task.id; let i = $index) {
      <app-lesson-item
        [layoutVariant]="layoutVariant()"
        [task]="task"
        [course]="course()"
        [index]="i"
      />
    }
  </div>
</div>

